// src/config/team-menu-config.js
export const teamMenuConfig = [
  {
    key: 'team',
    label: 'titles.team',
    routeName: 'team',
    showIf: () => true,
    showNumber: false
  },
  {
    key: 'players',
    label: 'titles.players',
    routeName: 'players',
    showIf: () => true,
    showNumber: true,
    numberPath: (team) =>
      team.estimate_players ? (typeof team.players === 'object' ? Object.keys(team.players).length : team.players) + '/' + team.estimate_players : ''
  },
  {
    key: 'staff',
    label: 'titles.staff',
    routeName: 'staff',
    showIf: () => true,
    showNumber: true,
    numberPath: (team) =>
      team.estimate_staff ? (typeof team.staff === 'object' ? Object.keys(team.staff).length : team.staff) + '/' + team.estimate_staff : ''
  },
  {
    key: 'acompanyants',
    label: 'titles.acompanyants',
    routeName: 'acompanyants',
    showIf: (team, event) => team && parseInt(team.mode) == 1 && event && parseInt(event.type_id) != 17,
    showNumber: true,
    numberPath: (team) =>
      team.estimate_acompanyants
        ? (typeof team.acompanyants === 'object' ? Object.keys(team.acompanyants).length : team.acompanyants) + '/' + team.estimate_acompanyants
        : ''
  },
  {
    key: 'sanctions',
    label: 'titles.sanctions',
    routeName: 'sanctions',
    showIf: (event) => event && parseInt(event.type_id) != 17,
    showNumber: false
  },
  {
    key: 'matches',
    label: 'titles.matches',
    routeName: 'matches',
    showIf: (event) => event && parseInt(event.type_id) != 17,
    showNumber: false
  },
  {
    key: 'travels',
    label: 'titles.transfers',
    routeName: 'travels',
    showIf: (team) => team && parseInt(team.transfer_visible) == 1,
    showNumber: false
  },
  {
    key: 'insurances',
    label: 'titles.insurance',
    routeName: 'insurances',
    showIf: (team, event) =>
      team && team.category && team.category.name !== 'INTEGRA' && parseInt(event.type_id) != 17,
    showNumber: false
  },
  {
    key: 'opening',
    label: 'titles.opening',
    routeName: 'opening',
    showIf: (team, event) =>
      event &&
      parseInt(event.type_id) == 1 &&
      team &&
      team.category &&
      team.category.name !== 'INTEGRA',
    showNumber: false
  },
  {
    key: 'finals',
    label: 'titles.finals',
    routeName: 'finals',
    showIf: (team, event) =>
      event &&
      parseInt(event.type_id) == 1 &&
      team &&
      team.category &&
      team.category.name !== 'INTEGRA',
    showNumber: false
  },
  {
    key: 'finals_saturday',
    label: 'titles.finals_saturday',
    routeName: 'finals_saturday',
    showIf: (team, event, user) => {
      if (!event || !team || !team.category || !team.category.max_age) return false

      const adminAges = ['F16', 'U12 - A', 'U12 - B']
      const userAges = ['F16', 'U12 - A', 'U12 - B']
      const validAges = user && user.admin ? adminAges : userAges

      return parseInt(event.type_id) === 1 && validAges.includes(team.category.max_age)
    },
    showNumber: false
  },
  {
    key: 'credentials',
    label: 'titles.credentials',
    routeName: 'credentials',
    showIf: (team, event) =>
      team &&
      parseInt(team.mode) === 2 &&
      event &&
      event.credentials &&
      team.category &&
      team.category.name !== 'INTEGRA',
    showNumber: false
  },
  {
    key: 'image-rights',
    label: 'titles.image-rights',
    routeName: 'image-rights',
    showIf: () => true,
    showNumber: false
  },
  {
    key: 'payments',
    label: 'titles.payments_and_budget',
    routeName: 'payments',
    showIf: (team, event) =>
      team && team.category && team.category.name !== 'INTEGRA' && event && parseInt(event.type_id) != 17,
    showNumber: false
  },
  {
    key: 'hotels',
    label: 'titles.hotels',
    routeName: 'hotels',
    showIf: (team) => team && parseInt(team.hotels_visible) == 1,
    showNumber: false
  }
]
